import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  KitInProgress,
  KitInProgressInteraction,
  KitInProgressInteractionType,
} from 'src/app/analyses/interfaces/analyses.types';

@Component({
  selector: 'app-claimed-kit-progress',
  templateUrl: './claimed-kit-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClaimedKitProgressComponent implements OnInit {
  @Input() kitInProgress: KitInProgress;

  kitClaimed: number;
  kitReceived: number;
  kitSent: Date;
  kitCompleted: Date;
  isKitSent = false;

  private kitUnclaimed: number;

  ngOnInit() {
    this.kitInProgress.interactions?.map(
      (interaction: KitInProgressInteraction) => {
        const interactedOnDate = Date.parse(interaction.interactedOn);
        switch (interaction.interaction) {
          case KitInProgressInteractionType.CLAIMED:
            // Test has been activated
            if (!this.kitClaimed || this.kitClaimed < interactedOnDate) {
              this.kitClaimed = interactedOnDate;
            }
            break;
          case KitInProgressInteractionType.UNCLAIMED:
            if (!this.kitUnclaimed || this.kitUnclaimed < interactedOnDate) {
              this.kitUnclaimed = interactedOnDate;
            }
            break;
          case KitInProgressInteractionType.RETURNED:
            // Sample has been received from the customer
            this.kitReceived = interactedOnDate;
            break;
          case KitInProgressInteractionType.SENT_TO_LABORATORY:
            this.kitSent = new Date(interactedOnDate);
            this.isKitSent = true;
            break;
        }
      }
    );

    if (this.kitUnclaimed > this.kitClaimed) {
      this.kitClaimed = null;
    }

    // This is a fallback for missing 'SentToLaboratory'
    if (this.kitReceived && !this.isKitSent) {
      const sentMilliseconds = this.kitReceived + 1000 * 60 * 60 * 24;
      this.kitSent = new Date(sentMilliseconds);
      this.isKitSent = Date.now() > sentMilliseconds;
    }
  }

  get title(): string {
    if (this.isKitSent) {
      return 'RESULTS.CLAIMED_KIT_PROGRESS.ANALYZING';
    } else if (this.kitReceived) {
      return 'RESULTS.CLAIMED_KIT_PROGRESS.PREPARING';
    }
    return 'RESULTS.CLAIMED_KIT_PROGRESS.WAITING';
  }
}
